/* global paginationData */
import $ from 'jquery';
/* eslint-disable no-unused-vars */
import pagination from 'paginationjs';
/* eslint-enable no-unused-vars */

const Pagination = (el) => {
    const moduleIndex = $(el).data('index');
    const moduleData = paginationData[moduleIndex];
    const {
        companyId,
        coverageTypeID,
        rowsPerPage,
        prevText,
        nextText,
    } = moduleData;

    const paginate = $(el).find('.js-pagination-paginate');

    const endpoint = '/wp-json/commissioned-research/v1/get-research-list';
    const companyParam = companyId > 0 ? `&companyId=${companyId}` : '';
    const url = `${endpoint}?coverageTypeID=${coverageTypeID}${companyParam}`;

    $(paginate).pagination({
        dataSource: function(done){
            $.getJSON(url, function(data) {
                // Dont show pagination if there are less than limit
                if(data.length > rowsPerPage) {
                    done(data);
                } else {
                    $(el).find('.js-pagination-loader').hide();
                }
            })
        },
        pageSize: rowsPerPage,
        pageRange: 1,
        prevText: prevText,
        nextText: nextText,
        callback: function(data) {
            $(el).find('.js-pagination-loader').hide();
            const html = renderCompanies(data, moduleData);
            $(el).find('.js-pagination-container').html(html);
        },
    });
};

const renderCompanies = (companies, moduleData) => {
    const {showMultipleCompanies} = moduleData;

    const rows = [];
    for(let i = 0; i < companies.length; i++) {
        const company = companies[i];
        const {publishedDate, companyUrl, companyName, link, title, pages} = company;

        const displayCompanyName = companyUrl !== '' ? `
            <a href="${companyUrl}">${companyName}</a>
        ` : companyName;
        const columnCompanyName = showMultipleCompanies ? `
            <td class="nav__td">${displayCompanyName}</td>
        ` : '';
        const displayResearchTitle = link !== '' ? `
            <a href="${link}" download>${title}</a>
        ` : title;

        rows.push(`
            <tr>
                <td class="nav__td nav__td--date">${publishedDate}</td>
                ${columnCompanyName}
                <td class="nav__td">${displayResearchTitle}</td>
                <td class="nav__td">${pages}</td>
            </tr>
        `);
    }
    return rows.join('');
};

export default Pagination;
